<template>
  <Layout style="height: 100%" class="main">
    <Sider hide-trigger collapsible :width="180" :collapsed-width="64" v-model="collapsed" class="left-sider"  :style="{overflow: 'hidden'}">
      <side-menu accordion ref="sideMenu" :active-name="$route.name" :collapsed="collapsed" class="mer" @on-select="turnToPage" :menu-list="menuList">
        <div class="logo-con">
          <img v-show="!collapsed" :src="maxLogo" key="max-logo" />
          <img v-show="collapsed" :src="minLogo" key="min-logo" />
        </div>
      </side-menu>
    </Sider>
    <Layout>
      <Header class="header-con">
        <header-bar :collapsed="collapsed" @on-coll-change="handleCollapsedChange">
          <user :user-avator="userAvator"/>
          <div @click="modal12 = true">
              <Badge :count="0" style="margin-top:10px;margin-right:30px;">
                <Icon type="ios-notifications-outline" class="ico" @click="modal12 = true"></Icon>
              </Badge>
              <Modal v-model="modal12" mask :styles="{top: '60px',right:'-35%'}" width="25%" class="modal" footer-hide @mouseout="modal12 = false">
                <Button type="primary" style="margin-bottom:5px;">全部已读</Button>
                  <Table :columns="columns12" :data="data6">
                      <template slot-scope="{ row }" slot="name">
                          <strong>{{ row.name }}</strong>
                      </template>
                      <template slot-scope="{ row, index }" slot="action">
                          <Button type="primary" size="small" style="margin-right: 5px" @click="show(index)" disabled>已读</Button>
                          <!-- <Button type="error" size="small" @click="remove(index)">Delete</Button> -->
                      </template>
                  </Table>
              </Modal>
          </div>
        </header-bar>
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <div class="tag-nav-wrapper">
            <tags-nav :value="$route" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag"/>
          </div>
          <Content class="content-wrapper">
            <keep-alive :include="cacheList">
            <Layout class="silayout" style="height:100%;">
                <Sider hide-trigger   width=200 v-show="showleft"><Aside style="float:left" v-show="leftShow"/></Sider>
                <Sider hide-trigger   width=25 v-show="showleftmin" style="margin-left:-6px;">
                  <div @click="showMin" v-show="showleft" style="height:100%"><Icon type="ios-arrow-back" style="margin-left:-4px;margin-top: 305px;"/></div>
                  <div @click="showMax" v-show="iconMan" style="height:100%"><Icon type="ios-arrow-forward" style="margin-left:-4px;margin-top: 305px;"/></div>
                </Sider>
                <Sider hide-trigger width=180  v-show="showlef" style="margin-left:-16px;background-color:#ccc;"><tree class="tree"/></Sider>
                <Layout >
                  <router-view style="height:100%;overflow-y:auto"/>
                </Layout>
            </Layout>
            </keep-alive>
          </Content>
        </Layout>
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import SideMenu from "./components/side-menu";
import HeaderBar from "./components/header-bar";
import TagsNav from "./components/tags-nav";
import User from "./components/user";
import Fullscreen from "./components/fullscreen";
import Language from "./components/language";
import ErrorStore from "./components/error-store";
import { mapMutations, mapActions, mapGetters } from "vuex";
import { getNewTagList, getNextRoute, routeEqual } from "@/libs/util";
import { getToken } from "@/libs/util";
// 2.0
import minLogo from "@/assets/images/logo_mindc.png";
import maxLogo from "@/assets/images/logo_dc.png";

// import minLogo from "@/assets/images/logo_mindc.png";
// import maxLogo from "@/assets/images/logo_dancodes.png";
// 盛科瑞
// import minLogo from "@/assets/images/logoSkr.png";
// import maxLogo from "@/assets/images/logoSk.png";

// import minLogo from "@/assets/images/logo_femtomes.png";
// import maxLogo from "@/assets/images/logo_fem_menu.png";

import Aside from "./../../components/trees/objectTree";
import Tree from "./../../components/trees/deviceTree";
import "./main.less";
export default {
  name: "Main",
  components: {
    SideMenu,
    HeaderBar,
    Language,
    TagsNav,
    Fullscreen,
    ErrorStore,
    Aside,
    User,
    Tree
  },
  data() {
    return {
      modal12: false,
      collapsed: false,
      minLogo,
      maxLogo,
      totalCount: 20,
      totlaPage: 2,
      pageSize: 10,
      currPage: 1,
      showleft: "",
      showlef: true,
      showleftmin: "",
      leftShow: true,
      iconMan: "",
      isFullscreen: false,
      ishowdraw: false,
      pStyle: {
        fontSize: "16px",
        color: "rgba(0,0,0,0.85)",
        lineHeight: "24px",
        display: "block",
        marginBottom: "16px"
      },
      treedata: [],
      columns12: [
        {
          title: "内容",
          slot: "name"
        },

        {
          title: "操作",
          slot: "action",
          width: 70,
          align: "center"
        }
      ],
      data6: [
        {
          name: "通知1",
        },
        {
          name: "通知2",
        },
        {
          name: "通知3",
        },
        {
          name: "通知4",
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["errorCount"]),
    tagNavList() {
      return this.$store.state.app.tagNavList;
    },
    tagRouter() {
      return this.$store.state.app.tagRouter;
    },
    userAvator() {
      return this.$store.state.user.avatorImgPath;
    },
    cacheList() {
      return this.tagNavList.length
        ? this.tagNavList
            .filter(item => !(item.meta && item.meta.notCache))
            .map(item => item.name)
        : [];
    },
    menuList() {
      return this.$store.getters.menuList;
    },
    local() {
      return this.$store.state.app.local;
    },
    hasReadErrorPage() {
      return this.$store.state.app.hasReadErrorPage;
    }
  },
  created() {
    if (this.$store.getters.menuList == "") {
      this.getMenuList(getToken()).then(rest => {
        let date = rest.data;
        if (date.code === 401) {
          this.handleLogOut().then(() => {
            this.$router.push({
              name: "login"
            });
          });
        }
      });
    }
  },
  methods: {
    ...mapMutations(["setBreadCrumb", "setTagNavList", "addTag", "setLocal"]),
    ...mapActions([
      "handleLogin",
      "getUserInfo",
      "getMenuList",
      "handleLogOut"
    ]),
    asd() {
      alert(1);
    },
    as() {
      alert(2);
    },
    turnToPage(route) {
      
      let { name, params, query } = {};
      if (typeof route === "string") name = route;
      else {
        name = route.name;
        params = route.params;
        query = route.query;
      }
      if (name.indexOf("isTurnByHref_") > -1) {
        window.open(name.split("_")[1]);
        return;
      }
      this.$router.push({
        name,
        params,
        query
      });
    },
    handleCollapsedChange(state) {
      this.collapsed = state;
    },
    handleCloseTag(res, type, route) {
      if (type === "all") {
        this.turnToPage(this.$config.homeName);
      } else if (routeEqual(this.$route, route)) {
        if (type !== "others") {
          const nextRoute = getNextRoute(this.tagNavList, route);
          this.$router.push(nextRoute);
        }
      }
      this.setTagNavList(res);
    },
    handleClick(item) {
      this.turnToPage(item);
    },
    showMin() {
      this.showleft = false;
      localStorage.setItem("showleft", this.showleft);
      this.iconMan = true;
      localStorage.setItem("iconMan", this.iconMan);
    },
    showMax() {
      // alert(1)
      this.showleft = true;
      localStorage.setItem("showleft", this.showleft);
      this.iconMan = false;
      localStorage.setItem("iconMan", this.iconMan);
    }
  },
  beforeEnter: (to, from, next) => {
    // ...
  },
  destroyed() {
  },
  watch: {
    $route(newRoute, oldRoute) {
      try {
        const { name, query, params, meta } = newRoute;
        this.addTag({
          route: { name, query, params, meta },
          type: "push"
        });
        if (this.$route.name == "data_browse_point") {
          this.collapsed = true;
        }
      } catch (e) {
        console.error(e);
      }
      let arr = [
        "trouble_info",
        "trouble_search",
        "monitor_info",
        "monitor_index",
        "engineering_management",
        "directory_attar",
        "engineering_attr",
        "point_attr",
        "directory_management",
        "md-funnel",
        "point_search",
        "new_engineering_0",
        "engineering_list",
        "engineering_index",
        "section",
        "3D_diagram",
        "2D_figure",
        "allData",
        "sensor_Figure",
        "relative_Displacement",
        "management",
        "3D_Stereogram",
        "data_browse_point",
        "data_browse_realtime",
        "new_engineering"
      ];
      if (arr.includes(newRoute.name)) {
        if (
          this.$route.name == "3D_diagram" ||
          this.$route.name == "2D_figure" ||
          this.$route.name == "allData" ||
          this.$route.name == "sensor_Figure" ||
          this.$route.name == "relative_Displacement" ||
          this.$route.name == "management" ||
          this.$route.name == "3D_Stereogram"
        ) {
          let showft =
            localStorage.getItem("showleft") == null
              ? true
              : localStorage.getItem("showleft");
          let showIc =
            localStorage.getItem("iconMan") == null
              ? false
              : localStorage.getItem("iconMan");
          this.showleft = showft == "false" ? false : true;
          this.iconMan = showIc == "false" ? false : true;
        } else {
          this.showleft = true;
        }
      } else if (newRoute.name == "connect_cha" && newRoute.query.status) {
        this.showleft =
          localStorage.getItem("showleft") == null
            ? true
            : localStorage.getItem("showleft");
      } else {
        this.showleft = false;
      }
      let ar = [
        "index_station",
        "station_properties",
        "index_node",
        "node_properties",
        "index_channel",
        "channel_properties",
        "channel_data",
        "index_sensor",
        "sensor_property",
        "sensor_data",
        "bulk_import"
      ];
      if (ar.includes(newRoute.name)) {
        this.showlef = true;
      } else {
        this.showlef = false;
      }

      let arrw = [
        "3D_diagram",
        "2D_figure",
        "allData",
        "sensor_Figure",
        "relative_Displacement",
        "management",
        "3D_Stereogram"
      ];
      if (arrw.includes(newRoute.name)) {
        this.showleftmin = true;
      } else if (newRoute.name == "connect_cha" && newRoute.query.status) {
        this.showleftmin = true;
      } else {
        this.showleftmin = false;
      }
      this.setBreadCrumb(newRoute);
      let newData = [];
      //   // newData = state.tagNavList
      // for(let i = this.tagNavList.length ; i > 0 ; i--){
      //   newData.push(
      //     this.tagNavList[i-1]
      //   )
      // }
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute));
      this.$refs.sideMenu.updateOpenName(newRoute.name);
    }
  },
  mounted() {
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    localStorage.setItem("showleft", true);
    localStorage.setItem("iconMan", false);
    let arr = [
      "trouble_info",
      "trouble_search",
      "monitor_info",
      "monitor_index",
      "engineering_management",
      "directory_attar",
      "engineering_attr",
      "point_attr",
      "directory_management",
      "md-funnel",
      "point_search",
      "new_engineering_0",
      "engineering_list",
      "engineering_index",
      "section",
      "3D_diagram",
      "2D_figure",
      "allData",
      "sensor_Figure",
      "relative_Displacement",
      "management",
      "3D_Stereogram",
      "data_browse_point",
      "data_browse_realtime",
      "new_engineering"
    ];
    if (arr.includes(this.$route.name)) {
      if (
        this.$route.name == "3D_diagram" ||
        this.$route.name == "2D_figure" ||
        this.$route.name == "allData" ||
        this.$route.name == "sensor_Figure" ||
        this.$route.name == "relative_Displacement" ||
        this.$route.name == "management" ||
        this.$route.name == "3D_Stereogram"
      ) {
        this.showleft =
          localStorage.getItem("showleft") == null
            ? true
            : localStorage.getItem("showleft");
      } else {
        this.showleft = true;
      }
    } else if (this.$route.name == "connect_cha" && this.$route.status) {
      this.showleft = true;
    } else {
      this.showleft = false;
    }
    let ar = [
      "index_station",
      "station_properties",
      "index_node",
      "node_properties",
      "index_channel",
      "channel_properties",
      "channel_data",
      "index_sensor",
      "sensor_property",
      "sensor_data",
      "bulk_import"
    ];
    if (ar.includes(this.$route.name)) {
      this.showlef = true;
    } else {
      this.showlef = false;
    }
    let arrw = [
      "3D_diagram",
      "2D_figure",
      "allData",
      "sensor_Figure",
      "relative_Displacement",
      "management",
      "3D_Stereogram"
    ];
    if (arrw.includes(this.$route.name)) {
      this.showleftmin = true;
    } else if (this.$route.name == "connect_cha" && this.$route.status) {
      this.showleftmin = true;
    } else {
      this.showleftmin = false;
    }
    this.setTagNavList();
    this.addTag({
      route: this.$store.state.app.homeRoute
    });
    this.setBreadCrumb(this.$route);
    // 设置初始语言
    this.setLocal(this.$i18n.locale);
    // 如果当前打开页面不在标签栏中，跳到homeName页
    if (!this.tagNavList.find(item => item.name === this.$route.name)) {
      this.$router.push({
        name: this.$config.homeName
      });
    }
  }
};
</script>

<style scoped>
.header-bar .custom-content-con .tree {
  position: absolute;
  left: 400px;
  /* float: left; */
}
.ivu-layout-sider {
  /* min-height: 500px; */
  background: #001529;
  /* border: 1px solid #e8eaec; */
  /* margin-right: 10px; */
}
.content-wrapper .silayout .ivu-layout-sider {
  /* height:690px; */
  background: white;
  /* border: 1px solid #e8eaec; */
  border-radius: 5px;
  padding-left: 10px;
  margin-right: 3px;
  overflow: hidden;
  /* overflow-y: scroll; */
  font-size: 14px;
  width: 160px !important;
}
.mer {
  display: block;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.demo-drawer-profile {
  font-size: 14px;
}
.demo-drawer-profile .ivu-col {
  margin-bottom: 12px;
}
.treeleft {
  margin: 10px 0;
  padding-left: 10px;
}
.tree {
  margin: 10px;
  /* height: 100%; */
  background-color: #cccccc;
}
.headerview {
  text-align: center;
  line-height: 80px;
  font-size: 24px;
  border-radius: 6px;
  text-shadow: 2px 2px 2px rgba(117, 117, 117, 0.678);
  border: 1px dashed rgba(156, 155, 155, 0.651);
}
.pages {
  margin: 40px;
}
.modal {
  width: 315px;
}
.ico{
  font-size: 25px !important;
}
</style>
